module.exports = __webpack_public_path__ + "assets/img/report-1.3850813d.jpg";